import { __makeTemplateObject, __assign } from '../../node_modules/tslib/tslib.es6.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { Text } from '@elseu/sdu-titan';
import styled from 'styled-components';
import { Person } from '../Person/Person.js';

var QuoteContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n\n  ", "\n"], ["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n\n  ", "\n"])), function (_a) {
  var variant = _a.variant,
    theme = _a.theme;
  return variant === 'card' && "\n      background: ".concat(theme.designTokens.colors.secondary10, ";\n      box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.05), 0px 10px 20px rgba(0, 0, 0, 0.1);\n      border-radius: ").concat(theme.borderRadius[2], ";\n      padding: ").concat(theme.spacing[6], ";\n  ");
});
var StyledQuote = styled(Text)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  margin: 0;\n  text-align: ", ";\n  padding-bottom: ", ";\n  word-break: break-word;\n  hyphens: auto;\n"], ["\n  margin: 0;\n  text-align: ", ";\n  padding-bottom: ", ";\n  word-break: break-word;\n  hyphens: auto;\n"])), function (_a) {
  var variant = _a.variant;
  return variant === 'card' ? 'left' : 'center';
}, function (_a) {
  var theme = _a.theme;
  return theme.spacing[8];
});
var PersonWrapper = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  max-width: 420px;\n"], ["\n  max-width: 420px;\n"])));
/**
 * Quote is a custom component that displays a quote and its author.
 *
 * @param {QuoteProps} props - The properties for the custom Quote component.
 * @returns {JSX.Element} The rendered custom Quote component.
 */
var Quote = function (_a) {
  var person = _a.person,
    children = _a.children,
    className = _a.className,
    variant = _a.variant;
  return jsxs(QuoteContainer, {
    className: className,
    variant: variant,
    children: [jsxs(StyledQuote, {
      as: "p",
      type: variant === 'card' ? 'paragraphSmall' : 'headerMedium',
      variant: variant,
      children: ["\u201C", children, "\u201D"]
    }), jsx(PersonWrapper, {
      children: variant === 'card' ? jsxs("div", {
        children: [jsx(Text, {
          type: "labelLargeBold",
          spaceAfter: 1,
          children: person.name
        }), jsx(Text, {
          type: "labelSmall",
          children: person.subtitle
        })]
      }) : jsx(Person, __assign({}, person))
    })]
  });
};
var templateObject_1, templateObject_2, templateObject_3;

export { Quote };
//# sourceMappingURL=Quote.js.map
